import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function AppFooter() {
    return (<Container fluid style={{ textAlign: "center", paddingTop: "50px" }} className="footer">
        <Row>
            <Col>
                <p>По вопросам сотрудничества:</p>
                <p><strong>Зверков Кирилл Андреевич</strong></p>
                <p>
                    <a href="tel:+79284010773">+7(928)401-07-73</a>
                </p>
                <p>
                    <a href="mailto:ca-pack@mail.ru ">ca-pack@mail.ru </a>
                </p>
            </Col>
        </Row>
        <span>&nbsp;К-Сервис&nbsp;&copy;&nbsp;2024</span>
    </Container>)
}